var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 3.75,
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 1.75,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.25C21.7426 14.25 22.75 15.2574 22.75 16.5C22.75 17.7426 21.7426 18.75 20.5 18.75C19.2574 18.75 18.25 17.7426 18.25 16.5C18.25 15.2574 19.2574 14.25 20.5 14.25Z",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10V6M5 10C4.29218 10 3.09088 10.2165 2.5 10.5M5 10C5.94086 10 7.66858 10.3541 8.82589 12C8.92869 12.1462 9.02616 12.3138 9.1176 12.5M1.5 11.5C1.68587 11.3141 1.75522 10.8573 2.5 10.5M2.5 10.5L3.5 6M2.5 10.5L3 11.75M9.5 6L10.3455 6C10.4402 6 10.5268 5.9465 10.5691 5.8618L10.8191 5.3618C10.9022 5.19558 10.7813 5 10.5955 5H2.40451C2.21866 5 2.09779 5.19558 2.1809 5.3618L2.4309 5.8618C2.47325 5.9465 2.55982 6 2.65451 6L3.5 6M9.5 6H3.5M9.5 6L9.96285 9.8514M10.5 12.5L9.96285 9.8514M10.5 12.5H9.1176M10.5 12.5H22M9.96285 9.8514L20.6415 11.3773C21.1341 11.4477 21.5 11.8696 21.5 12.3673V13.25C21.5 13.3881 21.3881 13.5 21.25 13.5H20.75M9.1176 12.5C9.53871 13.3578 9.83185 14.6118 9.92831 16M11.5 12V15.5M13 12V15M14.5 12V14.5M9.92831 16C9.94543 16.2463 9.95635 16.4968 9.9607 16.75C9.96308 16.8881 10.0748 17 10.2129 17H13.4814H16.75C16.8881 17 16.9992 16.888 17.0074 16.7501C17.0155 16.6148 17.03 16.4839 17.0505 16.3574M9.92831 16H8.65625M17.0505 16.3574C17.3672 14.4029 19.094 13.5 20 13.5H20.75M17.0505 16.3574H18.2031M20.75 13.5V14.2188",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5V8.75C15 8.61193 15.1119 8.5 15.25 8.5H15.75M16.5 10.5V8.75C16.5 8.61193 16.3881 8.5 16.25 8.5H15.75M15.75 8.5V7.5C15.75 6.3 16.25 6 16.5 6",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/Farm.6889c15257924613d109b1f4c6f51854.svg";
export { ForwardRef as ReactComponent };